import { Box } from "@mui/material";
import type { JSX } from "react";
import type { GuidFilter, SelectOption } from "../../api/types/objectTypes";
import MultiselectAutocomplete from "../common/MultiselectAutocomplete";
import { emptyGuid, getGuidFilterForSelectedValues } from "./objectFilterHelpers";

interface Props {
  filter: GuidFilter;
  onFilterChange: (filter: GuidFilter) => void;
  selectOptions?: SelectOption[];
}

const ObjectGuidFilterEditorContent = ({ filter, onFilterChange, selectOptions }: Props): JSX.Element => {
  const selectedIds = filter.values?.length
    ? filter.values
    : filter.value && filter.value !== emptyGuid
      ? [filter.value]
      : [];
  const options = [
    ...(selectOptions ?? []),
    ...selectedIds
      .filter((id) => !selectOptions?.some((option) => option.value === id))
      .map((id) => ({ value: id, label: id })),
  ];
  const values = options.filter((option) => selectedIds.includes(option.value));

  return (
    <Box sx={{ flexGrow: 1, minWidth: 0 }}>
      <MultiselectAutocomplete
        dense
        options={options}
        values={values}
        onSelected={(selected) =>
          onFilterChange(getGuidFilterForSelectedValues(selected.map((option) => option.value)))
        }
        getOptionLabel={(option) => option.label}
        getOptionValue={(option) => option.value}
        renderValue={(selected) => selected.map((option) => option.label).join(", ")}
      />
    </Box>
  );
};

export default ObjectGuidFilterEditorContent;
